/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Acwr_Risk_LowInputs */

const en_ui_acwr_risk_low = /** @type {(inputs: Ui_Acwr_Risk_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low risk`)
};

const de_ui_acwr_risk_low = /** @type {(inputs: Ui_Acwr_Risk_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedriges Risiko`)
};

/**
* | output |
* | --- |
* | "Low risk" |
*
* @param {Ui_Acwr_Risk_LowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_acwr_risk_low = /** @type {((inputs?: Ui_Acwr_Risk_LowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Acwr_Risk_LowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_acwr_risk_low(inputs)
	return de_ui_acwr_risk_low(inputs)
});